import c from 'classnames';
import Image from 'next/image';
import { Play } from 'phosphor-icons';
import { AssetMediaType } from './GallerySlide';
import { GalleryThumbnailButtonProps } from './GalleryThumbnailButton.types';

export const GalleryThumbnailButton = ({
  id,
  index,
  slide,
  currentSlide,
  setCurrentSlide,
  aspectRatio = 'aspect-video',
  useLabelledby = true,
}: GalleryThumbnailButtonProps) => {
  const label = slide.thumbnailLabel || slide.alt || `Thumbnail ${index + 1}`;
  const labelId = useLabelledby ? `${id}-label` : undefined;

  return (
    <button
      type="button"
      id={id}
      data-test={id}
      aria-current={currentSlide === index}
      aria-labelledby={labelId}
      aria-label={labelId ? undefined : label}
      onClick={() => setCurrentSlide(index)}
      className={c(
        'focus-outline bg-gray-100 lg:bg-gray-100 relative w-20 flex-shrink-0 rounded-thumbs px-2 outline-2 lg:w-full',
        aspectRatio,
        {
          'outline outline-offset-2 outline-blue': currentSlide === index,
          'hover:outline hover:outline-[2px] hover:outline-blue':
            currentSlide !== index,
        }
      )}
    >
      {labelId && (
        <span id={labelId} className="sr-only">
          {label}
        </span>
      )}

      {slide.type === AssetMediaType.ATTACHMENT_VIDEO && (
        <div className="absolute top-0 z-10 flex h-full w-full items-center justify-center rounded-thumbs bg-black/40 pl-2 pr-2 text-white">
          <Play size={20} weight="fill" />
        </div>
      )}

      <Image
        fill
        src={slide.thumbnail ? slide.thumbnail : slide.src}
        sizes="80px, (min-width: 1024px) 8vw"
        alt={label ?? ''}
        aria-hidden="true"
        className="rounded-thumbs object-cover"
      />
    </button>
  );
};
